import React, { Component } from 'react'
import { Spinner } from "scorpion-core";

import ConstainerTitulo from "../../../../../components/ConstainerTitulo";

import DinamicCrudCustomPesquisa from "../DinamicCrudCustomPesquisa";

import { RenderCustomForm, gerarRelatorioEspelho } from "scorpion-core";

import { temPermissao } from "../../../../../modules/permissoes/functions";
import Close from '@material-ui/icons/Close';
import Check from '@material-ui/icons/Check';

export default class DinamicCrudCustomForm extends Component {
    constructor(props) {
        super(props);
        this.salvar = this.salvar.bind(this);
        this.imprimir = this.imprimir.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.verificaPermissao = this.verificaPermissao.bind(this);

    }
    handleFormSubmit(props) {
        this.salvar(props, () => { this.props.sair(), this.props.showSuccess("Salvo com sucesso!") });
    }
    salvar(props, retorno) {
        const { customForm } = this.props;
        this.props.salvar(customForm, props, retorno)
    }

    imprimir(salvou) {
        const { customForm } = this.props;
        if (customForm.DebugValues) {
            delete customForm.DebugValues
        }
        gerarRelatorioEspelho(customForm, salvou.item)
    }

    verificaPermissao(permissao) {
        return temPermissao(this.props.customForm.permissao + "." + permissao);
    }
    render() {
        const { customForm, sair, handleSubmit } = this.props;
        let comps = [];
        let pesquisa = null;
        let titulo = "Titulo";


        if (customForm && customForm.componenteRoot) {
            comps = customForm.componenteRoot.componentes.slice();
            titulo = customForm.nomeForm

            pesquisa = <DinamicCrudCustomPesquisa componentes={comps} customFormUid={customForm.uid} titulo={"Pesquisa de " + customForm.nomeForm} global={customForm.global} />
        }
        return (<div>
            {customForm && customForm.componenteRoot ? (

                <ConstainerTitulo
                    titulo={customForm.nomeForm || "Item"}
                    acoes={[
                        { label: "Salvar", onClick: handleSubmit(this.handleFormSubmit), icon: <Check /> },
                        { label: "Cancelar", onClick: sair, icon: <Close /> }
                    ]}
                >
                    <div>
                        <RenderCustomForm componenteRoot={customForm.componenteRoot} propsview={{ ...this.props, verificaPermissao: this.verificaPermissao }} />
                    </div>
                </ConstainerTitulo>
                // <ContainerCrud propsForm={{ titulo: titulo }} {...this.props}
                //     salvar={this.salvar}
                //     imprimir={this.imprimir}
                //     permiteNovo={true}
                //     pesquisa={pesquisa}>
                //     <RenderCustomForm componenteRoot={customForm.componenteRoot} />
                // </ContainerCrud>
            ) : <Spinner />}
        </div>


        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicForms/components/DinamicCrudCustomFormDialog/DinamicCrudCustomForm.js